module.exports = __webpack_public_path__ + "static/img/bg-change-block-small2.e24fc90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-change-block-small2.png
// module id = Hl1x
// module chunks = 0